import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetOrganizationByUuidQuery,
  GetOrganizationByUuidQueryVariables,
} from "./GetOrganization.generated";

const GET_ORGANIZATION_BY_UUID: TypedDocumentNode<
  GetOrganizationByUuidQuery,
  GetOrganizationByUuidQueryVariables
> = gql`
  query GetOrganizationByUuid($uuid: String!) {
    organization(uuid: $uuid) {
      name
      uuid
      createdAt
      location
      numTeams
      numUsers
      isManualBilling
      stripeCustomerId
      emailDomain
      defaultTemplates {
        uuid
        name
        templateType
        description
        isFavourite
        sharingType
        createdAt
        updatedAt
      }
      teams {
        numUsers
        uuid
        name
        createdAt
        location
        users {
          uuid
          firstName
          lastName
        }
      }
      admins {
        uuid
        firstName
        lastName
      }
    }
  }
`;

export default GET_ORGANIZATION_BY_UUID;
